import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Moon, Sun } from 'lucide-react';
import LanguageSelector from './LanguageSelector';
import { useApp } from './AppContext';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentLanguage, darkMode, toggleDarkMode } = useApp();
  
  const translations = {
    en: {
      features: "Features",
      pricing: "Pricing",
      setup: "Setup",
      getStarted: "Get Started"
    },
    de: {
      features: "Funktionen",
      pricing: "Preise",
      setup: "Einrichtung",
      getStarted: "Loslegen"
    },
    fr: {
      features: "Fonctionnalités",
      pricing: "Prix",
      setup: "Configuration",
      getStarted: "Commencer"
    },
    bg: {
      features: "Функции",
      pricing: "Цени",
      setup: "Настройка",
      getStarted: "Започнете"
    },
    ro: {
      features: "Caracteristici",
      pricing: "Prețuri",
      setup: "Configurare",
      getStarted: "Începeți"
    }
  };

  const t = translations[currentLanguage];
  const isLandingPage = location.pathname === '/';

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-800">
      {/* Top Bar */}
      <div className="bg-gray-900 dark:bg-gray-950 text-white py-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-end items-center space-x-4">
          <button
            onClick={toggleDarkMode}
            className="p-2 rounded-lg bg-gray-800 dark:bg-gray-700 hover:bg-gray-700 dark:hover:bg-gray-600 transition-colors"
            aria-label="Toggle dark mode"
          >
            {darkMode ? (
              <Sun className="w-5 h-5 text-yellow-400" />
            ) : (
              <Moon className="w-5 h-5 text-gray-300" />
            )}
          </button>
          <LanguageSelector />
        </div>
      </div>

      {/* Header - Only show on landing page */}
      {isLandingPage && (
        <header className="py-6 px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto flex justify-between items-center">
            <div 
              onClick={() => navigate('/')}
              className="text-2xl font-bold text-indigo-600 dark:text-indigo-400 cursor-pointer"
            >
              zopai.cc
            </div>
            <nav className="hidden md:flex space-x-8">
              <a href="#features" className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white">
                {t.features}
              </a>
              <a href="#pricing" className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white">
                {t.pricing}
              </a>
              <a href="#setup" className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white">
                {t.setup}
              </a>
            </nav>
            <button 
              onClick={() => navigate('/get-started')}
              className="bg-indigo-600 dark:bg-indigo-500 text-white px-6 py-2 rounded-lg hover:bg-indigo-700 dark:hover:bg-indigo-600"
            >
              {t.getStarted}
            </button>
          </div>
        </header>
      )}

      {/* Main Content */}
      <main>{children}</main>
    </div>
  );
};

export default Layout;